<template>
  <div>
    <el-table :data="tableData" ref="tableRef" max-height="380" border stripe style="width: 900px" row-key="id"
      class="myTable lazy-table">
      <slot class="bode_slot"> 无数据 </slot>
    </el-table>
  </div>
</template>

<script>
export default {

  props: {
    data: { // 传入数据
      type: Array,
      default: () => []
    },
    config: { // table 配置项
      type: Object,
      default: () => { }
    }
  },

  data() {
    return {
      tableData: [], // 需要渲染的数据
      saveDATA: [], // 所有数据
      tableRef: null, // 设置了滚动的那个盒子
      tableWarp: null,
      fixLeft: null,
      fixRight: null,
      tableFixedLeft: null,
      tableFixedRight: null,
      scrollTop: 0,
      num: 0,
      start: 0,
      end: 42, // 3倍的pageList
      starts: 0, // 备份[保持与上一样]
      ends: 42, // 备份[保持与上一样]
      pageList: 14, // 一屏显示
      itemHeight: 41, // 每一行高度
      timeOut: 400 // 延迟
    }
  },


  methods: {
    onScroll() {
      this.scrollTop = this.tableRef.scrollTop
      this.num = Math.floor(this.scrollTop / (this.itemHeight * this.pageList))
    },
    creaData() {
      this.tableData = [], // 需要渲染的数据
        this.saveDATA = [], // 所有数据
        this.tableRef = null, // 设置了滚动的那个盒子
        this.tableWarp = null,
        this.fixLeft = null,
        this.fixRight = null,
        this.tableFixedLeft = null,
        this.tableFixedRight = null,
        this.scrollTop = 0,
        this.num = 0,
        this.start = 0,
        this.end = 42, // 3倍的pageList
        this.starts = 0, // 备份[保持与上一样]
        this.ends = 42, // 备份[保持与上一样]
        this.pageList = 14, // 一屏显示
        this.itemHeight = 41, // 每一行高度
        this.timeOut = 400 // 延迟
    },
    async init() {
      this.creaData()
      this.saveDATA = this.data
      this.tableData = this.saveDATA.slice(this.start, this.end)
      this.$nextTick(() => {

        // 设置了滚动的盒子
        this.tableRef = this.$refs.tableRef.bodyWrapper
        // 左侧固定列所在的盒子
        this.tableFixedLeft = document.querySelector(
          '.lazy-table .el-table__fixed .el-table__fixed-body-wrapper'
        )
        // 右侧固定列所在的盒子
        this.tableFixedRight = document.querySelector(
          '.lazy-table .el-table__fixed-right .el-table__fixed-body-wrapper'
        )
        /**
         * fixed-left | 主体 | fixed-right
         */
        // 主体改造
        // 创建内容盒子divWarpPar并且高度设置为所有数据所需要的总高度
        let divWarpPar = document.createElement('div')
        // 如果这里还没获取到saveDATA数据就渲染会导致内容盒子高度为0，可以通过监听saveDATA的长度后再设置一次高度
        divWarpPar.style.height = this.saveDATA.length * this.itemHeight + 'px'
        // 新创建的盒子divWarpChild
        let divWarpChild = document.createElement('div')
        divWarpChild.className = 'fix-warp'
        // 把tableRef的第一个子元素移动到新创建的盒子divWarpChild中
        divWarpChild.append(this.tableRef.children[0])
        // 把divWarpChild添加到divWarpPar中，最把divWarpPar添加到tableRef中
        divWarpPar.append(divWarpChild)
        this.tableRef.append(divWarpPar)

        // left改造
        let divLeftPar = document.createElement('div')
        divLeftPar.style.height = this.saveDATA.length * this.itemHeight + 'px'
        let divLeftChild = document.createElement('div')
        divLeftChild.className = 'fix-left'
        this.tableFixedLeft &&
          divLeftChild.append(this.tableFixedLeft.children[0])
        divLeftPar.append(divLeftChild)
        this.tableFixedLeft && this.tableFixedLeft.append(divLeftPar)

        // right改造
        let divRightPar = document.createElement('div')
        divRightPar.style.height = this.saveDATA.length * this.itemHeight + 'px'
        let divRightChild = document.createElement('div')
        divRightChild.className = 'fix-right'
        this.tableFixedRight &&
          divRightChild.append(this.tableFixedRight.children[0])
        divRightPar.append(divRightChild)
        this.tableFixedRight && this.tableFixedRight.append(divRightPar)

        // 被设置的transform元素
        this.tableWarp = document.querySelector(
          '.lazy-table .el-table__body-wrapper .fix-warp'
        )
        this.fixLeft = document.querySelector(
          '.lazy-table .el-table__fixed .el-table__fixed-body-wrapper .fix-left'
        )
        this.fixRight = document.querySelector(
          '.lazy-table .el-table__fixed-right .el-table__fixed-body-wrapper .fix-right'
        )

        this.tableRef.addEventListener('scroll', this.onScroll)
      })
    },
  },
  mounted() {
    this.init()
  },
  watch: {
    async num(newV) {
      // 因为初始化时已经添加了3屏的数据，所以只有当滚动到第3屏时才计算位移量
      if (newV > 1) {
        this.start = (newV - 1) * this.pageList
        this.end = (newV + 2) * this.pageList
        this.$nextTick(() => {
          // 计算偏移量
          this.tableWarp.style.transform = `translateY(${this.start *
            this.itemHeight}px)`
          if (this.fixLeft) {
            this.fixLeft.style.transform = `translateY(${this.start *
              this.itemHeight}px)`
          }
          if (this.fixRight) {
            this.fixRight.style.transform = `translateY(${this.start *
              this.itemHeight}px)`
          }
          this.tableData = this.saveDATA.slice(this.start, this.end)

        })
      } else {
        this.$nextTick(() => {
          this.tableData = this.saveDATA.slice(this.starts, this.ends)
          this.tableWarp.style.transform = `translateY(0px)`
          if (this.fixLeft) {
            this.fixLeft.style.transform = `translateY(0px)`
          }
          if (this.fixRight) {
            this.fixRight.style.transform = `translateY(0px)`
          }

        })
      }
    },
    data() {
      this.init()
    }
  }
}
</script>
<style lang="scss" scoped>
.myTable {

  // background-color: pink;
  /deep/ td {
    padding: 6px 0 !important;
  }
}

/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}

/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background: #666;
}

/deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: #ccc;
}

.bode_slot {
  background-color: pink;
}
</style>
